import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import NotificationModal from "../Modals/NotificationModal";
import { authActions } from "../../../redux/actions/auth.action";
import { MessageType } from "../../../constants/notificationModal.constants";

const VerifyEmail = () => {
  const registrationStatus = useSelector(
    (state) => state.LoginReducer.registrationStatus
  );
  const dispatch = useDispatch();

  useEffect(() => {
    const url = new URL(window.location.href);
    const userId = url.searchParams.get("userId");
    if (userId) {
      const token = url.searchParams.get("token");
      const code = url.searchParams.get("code");
      const userDetail = {
        userId: userId,
        token: token,
        code: code,
      };
      dispatch(authActions.registrationStatus(userDetail));
    }
    // eslint-disable-next-line
  }, []);

  const resendEmail = () => {
    const url = new URL(window.location.href);
    const userId = url.searchParams.get("userId");

    dispatch(authActions.resendEmail(userId));
  };

  return (
    <NotificationModal
      registrationStatus={registrationStatus.userStatus}
      registrationMessage={registrationStatus.message}
      messageType={MessageType.DOCUMENTS_SUBMITTED}
      resendEmail={() => resendEmail}
    />
  );
};

export default VerifyEmail;
